import { Snackbar, Alert, Box, SvgIcon, Typography, IconButton, AlertTitle } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import CheckCircleSmall from '@hapana/shared/web/styles/assets/svgs/check-circle-small.svg'
import UpRightIcon from '@hapana/shared/web/styles/assets/svgs/arrow-up-right.svg'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

import { styles } from './export-notification.styles'

const ExportNotification = () => {
  const { t } = useTranslation(['common', 'core'])

  const { dialogState, setDialogState } = useDialog()

  const closeNotification = () => {
    setDialogState({
      latestExportRequest: {},
      hasRequestDownloadNotification: false,
    })
  }

  return (
    <Snackbar
      sx={styles.root}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={dialogState.hasRequestDownloadNotification}
      onClose={closeNotification}
    >
      <Alert variant="success" sx={styles.alertRoot} icon={false}>
        <AlertTitle>
          <Box sx={styles.alertTitle}>
            <Box sx={styles.alertTitleContainer}>
              <SvgIcon component={CheckCircleSmall} sx={styles.icon} />
              <Typography variant="header4" sx={styles.completedRequest}>
                {t('exports.reports.completedRequest')}
              </Typography>
            </Box>

            <IconButton onClick={closeNotification} data-testid="export-notification-close-icon">
              <SvgIcon fontSize="small" component={CloseIcon} />
            </IconButton>
          </Box>
        </AlertTitle>

        <Box sx={styles.requestHistoryRoot}>
          <Box sx={styles.requestHistoryContainer}>
            <Typography variant="header4" sx={styles.requestHistoryTitle}>
              {t(`exports.reports.${dialogState.latestExportRequest.export}.title`)}
            </Typography>
            <Typography variant="body" sx={styles.requestHistoryDate}>
              {format(
                new Date(dialogState.latestExportRequest.updatedAt),
                "MMM dd, yyyy 'at' HH:mm a"
              )}
            </Typography>
          </Box>

          <IconButton
            size="small"
            onClick={() => {
              window.open(dialogState.latestExportRequest.url, '_blank', 'noopener')
            }}
            data-testid="export-notification-up-right-icon"
          >
            <SvgIcon component={UpRightIcon} fontSize="large" sx={styles.upRightIconStyles} />
          </IconButton>
        </Box>
      </Alert>
    </Snackbar>
  )
}

ExportNotification.propTypes = {}

export default ExportNotification
